<div class="container-fluid">
    <div class="row mb-3 align-items-end">
        <div class="col-md-3">
            <ds-form-field>
                <label ds-label for="dropdown1" class="form-label"
                >Brand<span style="color: red">*</span></label
                >
                <ds-select
                        id="carBrand1"
                        [labellingConfig]="{ placeholder: 'Select a brand...' }"
                        [options]="brandOptions"
                        [(ngModel)]="filters.brand"
                        (optionSelected)="onBrandChange($event)"
                        [showClearAll]="true"
                        required
                ></ds-select>
            </ds-form-field>
        </div>
        <div class="col-md-3">
            <ds-form-field>
                <label ds-label for="dropdown2" class="form-label">Version</label>
                <ds-select
                        id="carVersion1"
                        [labellingConfig]="{ placeholder: 'Select a version...' }"
                        [options]="filteredVersionOptions"
                        [(ngModel)]="filters.version"
                        (optionSelected)="onVersionChange($event)"
                ></ds-select>
            </ds-form-field>
        </div>

        <div class="col-md-3">
            <ds-form-field>
                <label ds-label for="dropdown3" class="form-label">Model</label>
                <ds-select
                        id="carModel1"
                        [labellingConfig]="{ placeholder: 'Select a model...' }"
                        [options]="filteredModelOptions"
                        [(ngModel)]="filters.model"
                        (optionSelected)="onModelChange($event)"
                ></ds-select>
            </ds-form-field>
        </div>

        <div class="col-md-3">
            <ds-form-field>
                <ds-checkbox-group>
                    <input
                            ds-input
                            type="checkbox"
                            id="dealerStock"
                            [(ngModel)]="dealerStockChecked"
                    />
                    <label ds-label for="dealerStock"
                    >Search all stock in the dealership</label
                    >
                </ds-checkbox-group>
            </ds-form-field>
        </div>
    </div>
    <div class="search-button-container">
        <button
                ds-button
                ds-loading
                class="btn btn-primary"
                icon="search"
                (click)="loadDemoStockData()"
                [disabled]="!isBrandSelected"
        >
            Search
        </button>
    </div>


<br/>
    <ds-box>
        <ds-box-content>
            <div>
                @if (isSearchDemoReplenishmentClicked) {
                    @if (rowsData && rowsData.length > 0) {
                        <div class="content_bg styled-section mt-4">
                            <div class="table-scroll-container">
                                <table class="ds-table zebra-table fixed-header-table w-100">
                                    <thead class="table-head">
                                    <tr>
                                        @for (column of columnData; track column.field) {
                                            <th>{{ column.headerName }}</th>
                                        }
                                    </tr>
                                    </thead>
                                    <tbody>
                                        @for (row of rowsData; track row.VIN) {
                                            <tr>
                                                @for (column of columnData; track column.field) {
                                                    <td>
                                                        @if (column.field === 'optionCount') {
                                                            <span
                                                                    style="cursor: pointer; text-decoration: underline"
                                                                    [ds-popover-trigger-for]="popover"
                                                            >
                          {{ row.options?.length || 0 }}
                        </span>
                                                            <ds-popover #popover>
                                                                <ds-box-header>Options</ds-box-header>
                                                                <ds-box-content>
                                                                    @for (opt of row.options; track opt.optionCode) {
                                                                        <div>{{ opt.optionCode }}- {{ opt.optionDescription }}
                                                                        </div>
                                                                    } @empty {
                                                                        <div>No options available</div>
                                                                    }
                                                                </ds-box-content>
                                                            </ds-popover>
                                                        } @else if (column.field === 'download') {
                                                            <div class="d-flex align-items-center">
                                                                <ds-icon
                                                                        icon="exchange"
                                                                        size="md"
                                                                        title="Request Vehicle"
                                                                        style="cursor: pointer; color: #037493"
                                                                        (click)="openModal(row.description, row.VIN, row.storageLocation)"
                                                                ></ds-icon>
                                                            </div>
                                                        } @else if (column.field === 'VIN') {
                                                            <a [href]="row.VIN | unitOverviewLink"
                                                               target="_blank"
                                                               style="font-weight: bold; color: #037493; text-decoration: none;">
                                                                {{ row.VIN }}
                                                            </a>
                                                        } @else {
                                                            {{ row[column.field] }}
                                                        }
                                                    </td>
                                                }
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    } @else {
                        <ng-container *ngTemplateOutlet="noStock"></ng-container>
                    }
                } @else {
                    <ng-container *ngTemplateOutlet="notYetSearched"></ng-container>
                }
            </div>
        </ds-box-content>
    </ds-box>

</div>
<ng-template #notYetSearched>
    <div class="no-data-message d-flex align-items-center justify-content-center" style="height: 60vh;">
        <div class="text-center">
            <h1>NO SEARCH RESULTS YET</h1>
            <p>Use the filters and click 'Search' to find what you need.</p>
        </div>
    </div>
</ng-template>

<ng-template #noStock>
    <div class="no-data-message d-flex align-items-center justify-content-center" style="height: 60vh;">
        <div class="text-center">
            <h1>NO SEARCH RESULTS FOUND</h1>
            <p>Try adjusting your search criteria in the filters.</p>
        </div>
    </div>
</ng-template>

<ds-modal
    #demoStockReplshModal
    [dimensionsConfig]="{ width: '420px' }"
    [ds-modal-trigger-for]="demoStockReplshModal"
    [(isModalOpen)]="demoStockReplshModalIsOpen"
    [detachFooter]="true"
>
    >
    <ds-box-header style="font-size: small; font-weight: bold">
        Request Demo Vehicle
    </ds-box-header>
    <ds-box-content>
        <div style="display: flex; align-items: center; gap: 8px">
            <span style="width: 130px">Vehicle:</span>
            <span>{{ modalData.description }}</span>
        </div>
        <br />
        <div style="display: flex; align-items: center; gap: 8px">
            <span style="width: 130px">VIN Number:</span>
            <span>{{ modalData.vin }}</span>
        </div>
        <br />
        <div style="display: flex; align-items: center; gap: 8px">
            <span style="margin-right: 10px; width: 180px">Purpose</span>
            <select
                    ds-select
                    name="purpose"
                    id="purpose"
                    class="form-control input-text"
                    [(ngModel)]="selectedPurpose"
                    required
            >
                <option value="" selected hidden>Please Select a Purpose</option>
                <option
                        *ngFor="let option of purposeOptions"
                        value="{{ option['id'] }}"
                >
                    {{ option['label'] }}
                </option>
            </select>
        </div>
    </ds-box-content>
    <ds-box-footer>
        <button
                ds-button
                style="
        background-color: #037493;
        color: white;
        padding-bottom: 8px;
        padding-right: 8px;
        padding-left: 8px;
        padding-top: 5px;
        border-radius: 3px;
        border: 1px solid #037493;
      "
                (click)="
        requestVehicle(
          modalData.vin,
          selectedPurpose,
          modalData.storageLocation
        )
      "
        >
            Request Vehicle
        </button>
    </ds-box-footer>
</ds-modal>
